import GradientTabButton from "@/lib/components/Button/GradientTabButton";
import { IconHeart, IconMusic, IconUpload } from "@tabler/icons-react";

export type BackgroundMusicDialogTab = "ALL_TRACKS" | "FAVORITES" | "ADD_MUSIC";

export function Tabs({
  activeTab,
  onTabChange,
}: {
  activeTab: BackgroundMusicDialogTab;
  onTabChange: (tab: BackgroundMusicDialogTab) => void;
}) {
  const tabs = [
    {
      id: "ALL_TRACKS" as const,
      label: "All Tracks",
      icon: IconMusic,
    },
    {
      id: "FAVORITES" as const,
      label: "Favourites",
      icon: IconHeart,
    },
    {
      id: "ADD_MUSIC" as const,
      label: "Add Music",
      icon: IconUpload,
    },
  ];

  return (
    <div className="flex flex-col gap-3 border-b border-grey-200 p-6">
      {tabs.map((tab) => (
        <GradientTabButton
          key={tab.id}
          icon={tab.icon}
          label={tab.label}
          isActive={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        />
      ))}
    </div>
  );
}
